import React from "react";

const skillsContent = [
  {buzword: "Reliability",contect: "Our company has been present in the market since 2006. Most of our clients have been with us since the beginning." },
  {buzword: "Experience",contect: "Our experts are professionals trained at international consulting firms and medium-sized domestic companies, representing a diverse and eminent professional knowledge base." },
  {buzword: "Professionalism",contect: "We offer a wide range of expertise in one place. Whether it is auditing, tax advice, due diligence, accounting, or payroll, you can rely on our colleagues." },
  {buzword: "Communication",contect: "Our team consists of young, customer-centric professionals with excellent communication skills, who can work smoothly in several languages." },
 
];

const SkillsEn = () => {
  return (
    <div class="col-12">
      <div class="row">
       <div class="col-2">
       </div>
    
    <div className="col-lg-8 col-sm-12 about-us-background">
      {skillsContent.map((val, i) => (
        <div className="col-12 choose " key={i}>
          <div class="row d-none d-lg-flex">
          <div  className="col-1">
          <div className={`c100 green-bg  ${val.skillClass}`}>
            <span><i className="fa fa-check dyar-orange" aria-hidden="true"> </i></span>
            
          </div>
          
          </div>
          <div className="col-11">
          <h5 class="poppins-font text-uppercase gray-text">{val.buzword}</h5>
          <p class="justify">{val.contect}</p>

          </div>
          </div>

          <div class="row d-flex d-lg-none">
          <div  className="col-2">
          <div className={`c100  green-bg  ${val.skillClass}`}>
            <span><i className="fa fa-check dyar-orange" aria-hidden="true"> </i></span>
          </div>
          </div>
          <div className="col-8">
          <h5 class="poppins-font text-uppercase about-us-margin">{val.buzword}</h5>
          </div>
          
          <div className="col-12">
          <p class="justify">{val.contect}</p>

          </div>
          </div>
        </div>
        
      ))}
    </div>
    </div>
    </div>
  );
};

export default SkillsEn;
